import handleBodyClasses from "./handleBodyClasses";

handleBodyClasses();